class Tariff {
    id;
    name;
    billable = false;
    absence = "None";
    customerName;
    fixedHours = -1;
    type;
    constructor(tariffJson) {
        this.id = tariffJson.id;
        this.name = tariffJson.name;
        this.customerName = tariffJson.customerName || ''; //change to be taken from json once api is updated.
        this.type = tariffJson.type;
        const tariffType = this.type ? this.type.toLocaleLowerCase() : "NO_TYPE_SPECIFIED";
        switch (tariffType) {
            case "vacation":
                this.absence = "Vacation";
                break;
            case "absenceshortterm":
                this.absence = "ShortTerm";
                break;
            case "absencelongterm":
                this.absence = "LongTerm";
                break;
            case "billable":
                this.billable = true;
                break;
        }
        if (tariffJson.fixedHours !== null && tariffJson.fixedHours !== 'null') {
            this.fixedHours = tariffJson.fixedHours;
        }
    }
}
export default Tariff;
